import { Injectable, inject } from '@angular/core';

import { NativeAppService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class CookieService {
    isConsented = false;
    private readonly nativeAppService = inject(NativeAppService);

    getCookie(name: string) {
        const ca: Array<string> = decodeURIComponent(document.cookie).split(';');
        const caLen: number = ca.length;
        const cookieName = `${name}=`;
        let c: string;

        for (let i = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) === 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
    }

    setCookie(name: string, value: string, expireDays: number, path: string = '') {
        const d: Date = new Date();
        d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
        const expires = `expires=${d.toUTCString()}`;
        const cpath = path ? `; path=${path}` : '';
        document.cookie = `${name}=${value}; ${expires}${cpath}; SameSite=Lax`;
    }

    // NFR - Services optimization - Remove
    consent(isConsent: boolean, e: any, COOKIE: string, EXPIRE_DAYS: number) {
        if (!isConsent) {
            return this.isConsented;
        } else if (isConsent) {
            this.setCookie(COOKIE, '1', EXPIRE_DAYS);
            this.isConsented = true;
            e.preventDefault();
        }
        return false;
    }

    isODR(odrName: string) {
        const nativeAppCookie = this.getCookie('NativeApp');
        const isODR: boolean = this.nativeAppService?.applicationName?.toLowerCase() === odrName || nativeAppCookie?.toLowerCase() === odrName;
        return isODR;
    }

    isPokerApp() {
        const nativeAppCookie = this.getCookie('NativeApp');
        return nativeAppCookie?.toLowerCase() == 'poker';
    }

    getFromCookie(key: any): boolean {
        if (this.getCookie(key) > '0') {
            return true;
        }
        return false;
    }
}

export enum ODR_NAME {
    CASINO_WODR = 'casinowodr',
    SPORTS_WODR = 'sportswodr',
}
